export default function Purity() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block bg-[#6B4E9C]/10 text-[#6B4E9C] px-4 py-2 rounded-full text-sm font-semibold whitespace-nowrap mb-6">
            두 번째 기준
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            본질에 대한 집중
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            오직 100% 포도 원액만 담습니다.<br />
            첨가물 없이 포도 그 자체의 농도를 지킵니다.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center mt-16">
          {/* 왼쪽 텍스트 */}
          <div className="space-y-8">
            <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
              <p className="font-semibold text-gray-900 text-xl">
                저희는 포도즙에 다른 것을 섞지 않습니다.
              </p>
              <p>
                포도즙은 포도만으로 완성됩니다.<br />
                불필요한 첨가를 하지 않습니다.<br />
                원료의 가치를 그대로 유지합니다.
              </p>
              <p className="text-2xl font-bold text-[#6B4E9C]">
                한 모금에서 순수함이 주는 깊이를 전달합니다.
              </p>
            </div>

            <div className="grid grid-cols-3 gap-6 pt-8">
              <div className="text-center">
                <div className="w-20 h-20 flex items-center justify-center bg-white rounded-full mx-auto mb-3 border-2 border-[#6B4E9C]">
                  <i className="ri-close-circle-line text-3xl text-[#6B4E9C]"></i>
                </div>
                <p className="font-bold text-gray-900">물 0%</p>
              </div>
              <div className="text-center">
                <div className="w-20 h-20 flex items-center justify-center bg-white rounded-full mx-auto mb-3 border-2 border-[#6B4E9C]">
                  <i className="ri-close-circle-line text-3xl text-[#6B4E9C]"></i>
                </div>
                <p className="font-bold text-gray-900">설탕 0%</p>
              </div>
              <div className="text-center">
                <div className="w-20 h-20 flex items-center justify-center bg-white rounded-full mx-auto mb-3 border-2 border-[#6B4E9C]">
                  <i className="ri-close-circle-line text-3xl text-[#6B4E9C]"></i>
                </div>
                <p className="font-bold text-gray-900">향료 0%</p>
              </div>
            </div>
          </div>

          {/* 오른쪽 이미지 */}
          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/c68b4d98425efaaf87884d60126a6533.jpg"
              alt="100% 포도 원액"
              className="w-full h-auto rounded-2xl shadow-2xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
